import React from 'react';
import Icon from '../Components/Icon';
import clsx from 'clsx';
import Select from './Select';
import { translate } from '../Services/translation';

const ListingPagination = (props) => {
  const { currentPageIndex, pageCount, onChange } = props;

  const createPageLink = (pageIndex) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set('page', pageIndex);
    return `${location.pathname}?${searchParams.toString()}`;
  };

  const defaultOnChange = (e, pageIndex) => {
    window.location.href = createPageLink(pageIndex);
  };

  if (pageCount < 2) {
    return null;
  }

  const pageOptions = [];
  for (let i = 1; i <= pageCount; i++) {
    pageOptions.push(
      <option key={i} value={i}>
        {i}
      </option>
    );
  }

  return (
    <div className="listing-pagination">
      <a
        href={createPageLink(1)}
        onClick={(e) => (onChange ? onChange(e, 1) : undefined)}
        className={clsx(
          'listing-pagination__link',
          currentPageIndex === 1 && 'listing-pagination__link--disabled'
        )}
      >
        <Icon
          name="Chevrons-Left"
          size={24}
          className="listing-pagination__link-icon listing-pagination__link-icon--chevrons"
        />
      </a>
      <a
        href={createPageLink(currentPageIndex - 1)}
        onClick={(e) =>
          onChange ? onChange(e, currentPageIndex - 1) : undefined
        }
        className={clsx(
          'listing-pagination__link',
          currentPageIndex === 1 && 'listing-pagination__link--disabled'
        )}
      >
        <Icon
          name="Caret-Left"
          size={24}
          className="listing-pagination__link-icon"
        />
      </a>
      <div className="listing-pagination__specific">
        <Select
          className="listing-pagination__select"
          value={currentPageIndex}
          onChange={(e) =>
            onChange
              ? onChange(e, Number(e.target.value))
              : defaultOnChange(e, Number(e.target.value))
          }
        >
          {pageOptions}
        </Select>
        <span className="listing-pagination__specific-text">
          {translate('pagination.of-total').replace('{0}', pageCount)}
        </span>
      </div>
      <a
        href={createPageLink(currentPageIndex + 1)}
        onClick={(e) =>
          onChange ? onChange(e, currentPageIndex + 1) : undefined
        }
        className={clsx(
          'listing-pagination__link',
          currentPageIndex === pageCount &&
            'listing-pagination__link--disabled'
        )}
      >
        <Icon
          name="Caret-Right"
          size={24}
          className="listing-pagination__link-icon"
        />
      </a>
      <a
        href={createPageLink(pageCount)}
        onClick={(e) => (onChange ? onChange(e, pageCount) : undefined)}
        className={clsx(
          'listing-pagination__link',
          currentPageIndex === pageCount &&
            'listing-pagination__link--disabled'
        )}
      >
        <Icon
          name="Chevrons-Right"
          size={24}
          className="listing-pagination__link-icon listing-pagination__link-icon--chevrons"
        />
      </a>
    </div>
  );
};

export default ListingPagination;
